import { Input } from "@/components/ui/input";

export default function DateRangePicker({ value, onChange, testid }) {
  const invalid = value.from && value.to && value.from > value.to;
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-2 bg-white border rounded-xl p-2 text-sm">
      <span className="text-slate-500">Du</span>
      <Input data-testid={`${testid}-from`} type="date" value={value.from} max={value.to || undefined}
        onChange={(e) => onChange({ ...value, from: e.target.value })} className="h-9 w-auto" />
      <span className="text-slate-500">au</span>
      <Input data-testid={`${testid}-to`} type="date" value={value.to} min={value.from || undefined}
        onChange={(e) => onChange({ ...value, to: e.target.value })} className="h-9 w-auto" />
      {invalid && <span data-testid={`${testid}-error`} className="text-xs text-red-600">La date de début doit précéder la date de fin</span>}
    </div>
  );
}

export const rangeQuery = (period, range) => {
  const p = new URLSearchParams({ period });
  if (period === "custom") {
    p.set("date_from", range.from);
    p.set("date_to", range.to);
  }
  return p.toString();
};

export const rangeReady = (period, range) => period !== "custom" || (range.from && range.to && range.from <= range.to);
